import React from 'react';
import PropTypes from 'prop-types';

import '../styles/index.scss';

class Accordion extends React.Component {
  constructor(props, context) {
    super(props, context);
    const {activeItem, items} = props;
    this.state = {
      activeItem: activeItem || (items[0].body && items[0].id) || true,
    };
  }

  expand(e, key, hasBody) {
    if (hasBody) {
      let {activeItem} = this.state;
      if (activeItem === key) {
        this.setState({
          activeItem: null,
        });
      } else {
        this.setState({
          activeItem: key,
        });
      }
      e && e.preventDefault();
      e && e.stopPropagation();
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.items !== this.props.items || nextState.activeItem !== this.state.activeItem;
  }

  render() {
    let {items} = this.props;
    let {activeItem} = this.state;

    return (
      <ul className="accordion">
        {items.map((item) => {
          let key = item.id;
          let isActive = key === activeItem;
          let className = `accordion__item ${isActive ? 'accordion__item--active' : ''}`;

          return (
            <li className={className} key={key}>
              <div className="accordion_head" onClick={(e) => this.expand(e, key, item.body)}>
                {item.head}
              </div>
              {item.body ? <div className="accordion_body">{item.body}</div> : null}
            </li>
          );
        })}
      </ul>
    );
  }
}

Accordion.propTypes = {
  items: PropTypes.array.isRequired,
  activeItem: PropTypes.string,
};

export default Accordion;
